import { get } from "../http";
import baseURL from "../base";
export default {
    eiSearch(data) {
        // 检索接口
        return get(`${baseURL.resourceURL}ei/search`, data);
    },
    eiDetalis(data) {
        // 详情接口
        return get(`${baseURL.resourceURL}ei/detail`, data);
    },
    eiPage(data) {
        // 分页接口
        return get(`${baseURL.resourceURL}ei/next-page`, data);
    },
    eiRefine(data) {
        // 分面数据
        return get(`${baseURL.resourceURL}ei/refine`, data);
    },
};
